import { ElevatorsContainer } from '../../containers/advancedFilters/ElevatorsContainer';
import { IFilter } from '../../types/filters';

export const elevators: IFilter = {
  component: ElevatorsContainer,
};
